import SyncableModel from './SyncableModel';

export default class Currency extends SyncableModel {
    static name = 'Currency'

    _fillable = [
      'id',
      'numeric_code',
      'name',
      'symbol',
      'fractions_digits',
      'created_at', 'updated_at',
      'synced_at', 'deleted_at',
    ]

    incrementing = false

    _keyType = 'string'

    static syncOnly = true

    static endpoint = '/currencies'

    static searchables = ['id', 'name', 'symbol']

}
